import { hasWindow } from "@omni/utils/dom.utils";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";

import {
    apiDataReducerManager,
    apiReducer,
    valueReducerManager
} from "@/redux/modules/reducers";

import { create as createApi } from "./modules/api/api";
import { $ApiErrorsModuleName } from "./modules/api/errors/errors.types";
import { $LoadingModuleName } from "./modules/api/loading/loading.types";
import {
    $ApiModuleName,
    $DataModuleName,
    $ValueModuleName,
    IState,
    TStore
} from "./store.types";

const initialRootState: IState = {
    [$ApiModuleName]: {
        [$LoadingModuleName]: {},
        [$DataModuleName]: {},
        [$ApiErrorsModuleName]: {}
    },
    [$ValueModuleName]: {}
};

const createReduxStore = (initialData: IState = initialRootState) => {
    const emptyMethod = (f: any) => f;
    const devTools =
        (hasWindow() &&
            window?.__REDUX_DEVTOOLS_EXTENSION__?.({
                name: `${document.title} - core`
            })) ||
        emptyMethod;

    // remove api param => create api in create-api-module
    const enhancers = compose(
        applyMiddleware(thunk.withExtraArgument(createApi())),
        devTools
    );

    // @ts-expect-error
    const store = createStore(
        combineReducers({
            [$ApiModuleName]: apiReducer,
            [$ValueModuleName]: valueReducerManager.reduce
        }),
        initialData,
        enhancers
    ) as Partial<TStore>;

    store.reducerManagers = {
        [$ValueModuleName]: valueReducerManager,
        [$ApiModuleName]: {
            [$DataModuleName]: apiDataReducerManager
        }
    };

    return store as TStore;
};

export { createReduxStore };
